import { render, staticRenderFns } from "./DataVerificationCard.vue?vue&type=template&id=0b36cbe8&"
import script from "./DataVerificationCard.vue?vue&type=script&lang=js&"
export * from "./DataVerificationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports